import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * ModalConfirmacionPagoSuscripcion
 * Modal para confirmar si se cobra la diferencia ahora o en el siguiente pago
 * al agregar un usuario a una suscripción existente
 */
const ModalConfirmacionPagoSuscripcion = ({ show, onHide, diferencia, moneda, onConfirm }) => {
    
    const handleCobrarAhora = () => {
        onConfirm(true); // true = cobrar ahora
    };

    const handleCobrarDespues = () => {
        onConfirm(false); // false = cobrar en siguiente renovación
    };

    return (
        <Modal show={show} onHide={onHide} size="md" backdrop="static" centered>
            <Modal.Header closeButton className="bg-primary bg-opacity-10">
                <Modal.Title className="d-flex align-items-center">
                    <FontAwesomeIcon icon="credit-card" className="me-2 text-primary" />
                    Confirmación de Pago
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info" className="mb-3">
                    <FontAwesomeIcon icon="info-circle" className="me-2" />
                    <strong>Licencia con Suscripción Activa</strong>
                </Alert>

                <p className="mb-3">
                    Al agregar este usuario, la suscripción aumentará su costo mensual.
                </p>

                <div className="bg-light p-3 rounded mb-3">
                    <Row className="align-items-center">
                        <Col xs={6}>
                            <div className="text-muted small fw-bold">Total a cobrar:</div>
                        </Col>
                        <Col xs={6} className="text-end">
                            <div className="fs-4 fw-bold text-success">
                                ${Number.parseFloat(diferencia).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {moneda}
                            </div>
                        </Col>
                    </Row>
                </div>

                <p className="fw-bold mb-2">¿Cuándo deseas realizar el cobro?</p>

                <div className="d-grid gap-2">
                    <Button 
                        variant="success" 
                        onClick={handleCobrarAhora}
                    >
                        <FontAwesomeIcon icon="bolt" className="me-2" />
                        Cobrar Ahora
                    </Button>

                    <Button 
                        variant="outline-primary" 
                        onClick={handleCobrarDespues}
                    >
                        <FontAwesomeIcon icon="calendar-alt" className="me-2" />
                        Cobrar en Siguiente Renovación
                    </Button>
                </div>

                <Alert variant="warning" className="mt-3 mb-0">
                    <small>
                        <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
                        El usuario será creado inmediatamente, independientemente de tu selección.
                    </small>
                </Alert>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="light" onClick={onHide}>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalConfirmacionPagoSuscripcion.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    diferencia: PropTypes.number.isRequired,
    moneda: PropTypes.string,
    onConfirm: PropTypes.func.isRequired
};

ModalConfirmacionPagoSuscripcion.defaultProps = {
    moneda: 'MXN'
};

export default ModalConfirmacionPagoSuscripcion;
